import React from 'react';
import { Link } from 'react-router-dom';
import { WrenchIcon, TrashIcon } from '@heroicons/react/20/solid'; // Removed ChevronDownIcon

// Helper function to combine class names
function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

// Main actions for Configure
function Actions({ actions }) {
  return (
    <div>
      {actions.map((action) => {
        return (
          <div key={action.name} className="mb-4 last:mb-0">
            <div className="mt-4">
              {action.link ? (
                <Link 
                  to={action.link} 
                  className="w-full block text-center text-sm px-4 py-3 rounded-lg transition-all duration-100 font-bold tracking-wide"
                  style={{
                    background: 'linear-gradient(135deg, #E74C3C, #C0392B)',
                    color: '#FFFFFF',
                    border: '2px solid rgba(231, 76, 60, 0.6)',
                    fontFamily: '"Share Tech Mono", monospace',
                    textShadow: '0 0 4px rgba(0, 0, 0, 0.3)'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background = 'linear-gradient(135deg, #C0392B, #A93226)';
                    e.target.style.transform = 'translateY(-1px)';
                    e.target.style.boxShadow = '0 4px 12px rgba(231, 76, 60, 0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = 'linear-gradient(135deg, #E74C3C, #C0392B)';
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = 'none';
                  }}
                >
                  🎮 {action.name.toUpperCase()}
                </Link>
              ) : (
                <button 
                  onClick={action.action} 
                  className="w-full block text-center text-sm px-4 py-3 rounded-lg transition-all duration-100 font-bold tracking-wide"
                  style={{
                    background: 'linear-gradient(135deg, #E74C3C, #C0392B)',
                    color: '#FFFFFF',
                    border: '2px solid rgba(231, 76, 60, 0.6)',
                    fontFamily: '"Share Tech Mono", monospace',
                    textShadow: '0 0 4px rgba(0, 0, 0, 0.3)'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background = 'linear-gradient(135deg, #C0392B, #A93226)';
                    e.target.style.transform = 'translateY(-1px)';
                    e.target.style.boxShadow = '0 4px 12px rgba(231, 76, 60, 0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = 'linear-gradient(135deg, #E74C3C, #C0392B)';
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = 'none';
                  }}
                >
                  🎮 {action.name.toUpperCase()}
                </button>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}

// Additional actions
function AdditionalActions({ moreActions }) {
  const getActionEmoji = (actionName) => {
    switch(actionName.toLowerCase()) {
      case 'play': return '▶️';
      case 'delete': return '🗑️';
      case 'change name': return '✏️';
      case 'change status': return '🔄';
      default: return '⚡';
    }
  };

  return (
    <div>
      {moreActions.map((action) => {
        const isDelete = action.name.toLowerCase() === 'delete';
        
        return (
          <div key={action.name} className="mb-2 last:mb-0">
            {action.link ? (
              <Link 
                to={action.link} 
                className="w-full block text-center text-sm px-4 py-2.5 rounded-lg transition-all duration-100 font-bold tracking-wide"
                style={{
                  background: isDelete ? 'rgba(231, 76, 60, 0.1)' : 'rgba(52, 73, 94, 0.6)',
                  color: isDelete ? '#E74C3C' : '#F1C40F',
                  border: isDelete ? '2px solid rgba(231, 76, 60, 0.4)' : '1px solid rgba(241, 196, 15, 0.4)',
                  fontFamily: '"Share Tech Mono", monospace'
                }}
                onMouseEnter={(e) => {
                  if (isDelete) {
                    e.target.style.background = 'rgba(231, 76, 60, 0.2)';
                    e.target.style.border = '2px solid rgba(231, 76, 60, 0.6)';
                  } else {
                    e.target.style.background = 'rgba(241, 196, 15, 0.1)';
                    e.target.style.border = '1px solid rgba(241, 196, 15, 0.6)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (isDelete) {
                    e.target.style.background = 'rgba(231, 76, 60, 0.1)';
                    e.target.style.border = '2px solid rgba(231, 76, 60, 0.4)';
                  } else {
                    e.target.style.background = 'rgba(52, 73, 94, 0.6)';
                    e.target.style.border = '1px solid rgba(241, 196, 15, 0.4)';
                  }
                }}
              >
                {getActionEmoji(action.name)} {action.name.toUpperCase()}
              </Link>
            ) : (
              <button 
                onClick={action.action} 
                className="w-full block text-center text-sm px-4 py-2.5 rounded-lg transition-all duration-100 font-bold tracking-wide"
                style={{
                  background: isDelete ? 'rgba(231, 76, 60, 0.1)' : 'rgba(52, 73, 94, 0.6)',
                  color: isDelete ? '#E74C3C' : '#F1C40F',
                  border: isDelete ? '2px solid rgba(231, 76, 60, 0.4)' : '1px solid rgba(241, 196, 15, 0.4)',
                  fontFamily: '"Share Tech Mono", monospace'
                }}
                onMouseEnter={(e) => {
                  if (isDelete) {
                    e.target.style.background = 'rgba(231, 76, 60, 0.2)';
                    e.target.style.border = '2px solid rgba(231, 76, 60, 0.6)';
                  } else {
                    e.target.style.background = 'rgba(241, 196, 15, 0.1)';
                    e.target.style.border = '1px solid rgba(241, 196, 15, 0.6)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (isDelete) {
                    e.target.style.background = 'rgba(231, 76, 60, 0.1)';
                    e.target.style.border = '2px solid rgba(231, 76, 60, 0.4)';
                  } else {
                    e.target.style.background = 'rgba(52, 73, 94, 0.6)';
                    e.target.style.border = '1px solid rgba(241, 196, 15, 0.4)';
                  }
                }}
              >
                {getActionEmoji(action.name)} {action.name.toUpperCase()}
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default function ActionsCard({ actions }) {
  // Filter the actions for Configure, and other actions for the dropdown
  const mainActions = actions.filter(action => ['Open Editor'].includes(action.name));
  const moreActions = actions.filter(action => ['Play', 'Change name', 'Change status', 'Delete'].includes(action.name));

  // Sort so that Play is first, Delete is last, and other actions in between
  moreActions.sort((a, b) => {
    if (a.name === 'Play') return -1;
    if (b.name === 'Delete') return -1;
    if (a.name === 'Delete') return 1;
    return 0;
  });

  return (
    <div className="rounded-xl px-5 pt-3 pb-5" style={{
      background: 'linear-gradient(135deg, #2C3E50, #34495E)',
      border: '2px solid rgba(241, 196, 15, 0.4)',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)'
    }}>
      <div className="text-xs uppercase font-bold tracking-wide mb-2" style={{
        color: '#F1C40F',
        textShadow: '0 0 8px rgba(241, 196, 15, 0.5)',
        fontFamily: '"Share Tech Mono", monospace'
      }}>
        ⚡ QUICK ACTIONS
      </div>
      <Actions actions={mainActions} />
      {moreActions.length > 0 && (
        <div className="mt-4">
          <AdditionalActions moreActions={moreActions} />
        </div>
      )}
    </div>
  );
}